function getConfig(name, defaultValue = null) {
  // If inside a docker container with injected ENV, use window.ENV
  if (typeof window !== "undefined" && window.ENV !== undefined && window.ENV[name]) {
    return window.ENV[name];
  }

  // Vite static access for known env vars (Vite does not support dynamic import.meta.env[name])
  if (name === "VITE_BACKEND_URL" && typeof import.meta !== "undefined" && import.meta.env && import.meta.env.VITE_BACKEND_URL) {
    return import.meta.env.VITE_BACKEND_URL;
  }
  if (name === "REACT_APP_BACKEND_URL" && typeof import.meta !== "undefined" && import.meta.env && import.meta.env.REACT_APP_BACKEND_URL) {
    return import.meta.env.REACT_APP_BACKEND_URL;
  }
  if (name === "VITE_HOURS_CLOSE_TICKETS_AUTO" && typeof import.meta !== "undefined" && import.meta.env && import.meta.env.VITE_HOURS_CLOSE_TICKETS_AUTO) {
    return import.meta.env.VITE_HOURS_CLOSE_TICKETS_AUTO;
  }
  if (name === "REACT_APP_HOURS_CLOSE_TICKETS_AUTO" && typeof import.meta !== "undefined" && import.meta.env && import.meta.env.REACT_APP_HOURS_CLOSE_TICKETS_AUTO) {
    return import.meta.env.REACT_APP_HOURS_CLOSE_TICKETS_AUTO;
  }

  return defaultValue;
}

export function getBackendUrl() {
  let url = getConfig("VITE_BACKEND_URL") || getConfig("REACT_APP_BACKEND_URL");

  // Fallback: If running in browser on a production domain and no env var was injected
  if (!url && typeof window !== "undefined" && window.location && window.location.hostname) {
    const hostname = window.location.hostname;
    if (hostname !== "localhost" && hostname !== "127.0.0.1") {
      const apiHost = hostname.startsWith("app.")
        ? hostname.replace(/^app\./, "api.")
        : `api.${hostname}`;
      url = `${window.location.protocol}//${apiHost}`;
    }
  }

  url = url || "http://localhost:8080/";

  // Clean redundant :443 on https
  if (url.startsWith("https://")) {
    url = url.replace(/:443(\/|$)/, "$1");
  }

  // Ensure trailing slash
  if (!url.endsWith("/")) {
    url += "/";
  }

  return url;
}

export function getHoursCloseTicketsAuto() {
  return getConfig("VITE_HOURS_CLOSE_TICKETS_AUTO") || getConfig("REACT_APP_HOURS_CLOSE_TICKETS_AUTO");
}
